import { ImageOff } from 'lucide-react'
import React, { useState } from 'react'

import { cn } from '@/lib/utils'

import { SwatchGridProps } from './swatch-grid.types'

export function SwatchGrid({
  items,
  value,
  onSelect,
  columns = 3,
  emptyMessage,
  className,
}: SwatchGridProps) {
  const [failedKeys, setFailedKeys] = useState<Set<string>>(new Set())

  if (!items.length) {
    return emptyMessage ? (
      <p className="text-xs italic text-light-4">{emptyMessage}</p>
    ) : null
  }

  return (
    <div
      className={cn('grid gap-2', className)}
      style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}
    >
      {items.map((item, index) => {
        const active = value !== undefined && value === item.value
        const key = `${item.value}-${index}`
        const thumbnailFailed = item.thumbnail && failedKeys.has(key)
        return (
          <button
            key={key}
            type="button"
            title={item.label}
            aria-pressed={active}
            onClick={() => onSelect(item.value)}
            className={cn(
              'flex items-center justify-center rounded-lg border p-2 text-xs transition-colors',
              active
                ? 'border-rest-p1 bg-rest-p1 text-white'
                : 'border-neutral-1 bg-white text-light-2 hover:border-rest-p1'
            )}
          >
            {item.thumbnail && !thumbnailFailed ? (
              <img
                src={item.thumbnail}
                alt={item.label ?? ''}
                className="h-10 w-full object-contain"
                onError={() => setFailedKeys((prev) => new Set(prev).add(key))}
              />
            ) : thumbnailFailed ? (
              <span
                title="Failed to load"
                className="flex h-10 w-full items-center justify-center text-light-4"
              >
                <ImageOff className="h-5 w-5" />
              </span>
            ) : item.icon ? (
              <span className="flex h-5 w-5 items-center justify-center [&_svg]:h-5 [&_svg]:w-5">
                {item.icon}
              </span>
            ) : (
              item.label
            )}
          </button>
        )
      })}
    </div>
  )
}
